const foo = [
  // Rest Api = https://restfulapi.net/wp-content/uploads/rest.png
  // react = https://www.svgrepo.com/show/354259/react.svg
  // tailwind = https://www.svgrepo.com/show/374118/tailwind.svg
  // webpack = https://www.svgrepo.com/show/354552/webpack.svg
  // style components = https://www.styled-components.com/atom.png
  // javascript = https://www.svgrepo.com/show/353925/javascript.svg
  {
    id: 1,
    name: "Reeturaj.com",
    type: "Portfolio Site",
    description:
      "Personal portfolio and a personal blog is always a nice thing to have, so I handcrafted one for myself to showcase my blogs and projects",
    tools:
      "https://www.svgrepo.com/show/354259/react.svg https://www.styled-components.com/atom.png",
    link: "https://reeturaj.com",
  },
  {
    id: 2,
    name: "API Projects",
    type: "Rest API",
    description:
      "These are the sample projects based on the concept of restful API.",
    tools:
      "https://restfulapi.net/wp-content/uploads/rest.png https://www.svgrepo.com/show/354259/react.svg https://www.svgrepo.com/show/374118/tailwind.svg https://www.svgrepo.com/show/354552/webpack.svg",
    link: "https://apiprojects9876.netlify.app/",
  },
  {
    id: 3,
    name: "404  Page Error",
    type: "Web Design",
    description:
      "Web page design designated to be displayed when a request triggers the HTTP 404 response code.",
    tools: "https://www.svgrepo.com/show/448222/figma.svg",
    link: "https://www.behance.net/gallery/153948427/404-ERROR-PAGE",
  },
  {
    id: 4,
    name: "Pig Game",
    type: "Game",
    description:
      "The game of Pig is dice game in which two players race to reach 100 points. Each turn, a player repeatedly rolls a die until either a 1 is rolled or the player holds and scores the sum of the rolls.",
    tools: "https://www.svgrepo.com/show/353925/javascript.svg",
    link: "https://12otherways.github.io/Pig-game/",
  },
];

export default foo;
